export const voucherStatuses = {
  available: { value: 1, name: '可用', tagType: 'success' },
  used: { value: 2, name: '已使用', tagType: 'info' },
  expired: { value: 3, name: '已过期', tagType: 'danger' },
};

export function findVoucherStatus(value) {
  for (const key in voucherStatuses) {
    if (value === voucherStatuses[key].value) return [voucherStatuses[key]];
  }
  return [];
}

export function isValidVoucherStatus(value) {
  return Object.values(voucherStatuses).some(s => s.value === value);
}
